module.exports = __webpack_public_path__ + "static/media/document-icon.c327c391.svg";